import React, { useState } from 'react';
import PragueAreasCard from '../pragueAreasCard/PragueAreasCard';
import './PragueAreas.css';
import languageStore from '../../store/languageStore';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

const PragueAreas = ({ areas }) => {
  const [visibleCount, setVisibleCount] = useState(8);
  const navigate = useNavigate();

  const handleShowMore = () => {
    setVisibleCount(visibleCount + 8);
  };

  return (
    <div className="prague-areas">
      <h2 className='prague-title'>{t("ATTRACTIONS_prague_areas")}</h2>
      <div className="prague-areas-grid">
        {areas.slice(0, visibleCount).map((area, index) => (
          <PragueAreasCard 
            key={index} 
            imageSrc={"https://static2.praguecoolpass.com/"+area?.images[0]} 
            title={area?.content[languageStore?.selectedLanguage]?.title} 
            description={area?.content[languageStore?.selectedLanguage]?.subtitle ? (area?.content[languageStore?.selectedLanguage]?.subtitle ): (area?.content?.en?.subtitle) } 
          />
        ))}
      </div>
      {visibleCount <= areas.length && (
        <button className="show-all-button" onClick={() => navigate('/under-construction')}>{t("ATTRACTIONS_show_all_areas").toUpperCase()}</button>
      )}
    </div>
  );
};

export default PragueAreas;
